"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _Panorama = _interopRequireDefault(require("@mui/icons-material/Panorama"));
var _mui = require("tss-react/mui");
var _styles = require("@mui/material/styles");
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _FileInput = _interopRequireDefault(require("../FileInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      margin: theme.spacing(2, 0, 1)
    },
    labelAndPreviewWrapper: _defineProperty({
      display: 'flex',
      flexDirection: 'column'
    }, theme.breakpoints.down('md'), {
      marginBottom: theme.spacing(3)
    }),
    label: {
      color: theme.palette.darkGrey.main
    },
    previewContainer: _defineProperty({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 147,
      borderRadius: 7,
      color: theme.palette.lightGrey.dark,
      boxShadow: theme.customShadows["default"],
      padding: theme.spacing(1),
      overflow: 'hidden',
      position: 'relative'
    }, theme.breakpoints.down('md'), {
      marginRight: theme.spacing(0)
    }),
    previewImage: {
      maxWidth: '90%',
      height: '100%',
      objectFit: 'contain',
      borderRadius: 7
    },
    imageInfo: {
      color: theme.palette.darkGrey.main
    },
    previewAndDeleteContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: (0, _styles.alpha)(theme.palette.background.backdrop, 0.5),
      color: '#fff',
      position: 'absolute',
      padding: theme.spacing(0, 1),
      bottom: theme.spacing(0),
      left: theme.spacing(0)
    },
    previewText: {
      fontWeight: 'bold'
    },
    deleteIcon: {
      color: '#fff',
      cursor: 'pointer',
      background: 'transparent',
      '&:hover': {
        background: 'transparent'
      }
    }
  };
});
var ImageInput = function ImageInput(_ref) {
  var name = _ref.name,
    files = _ref.value,
    error = _ref.error,
    label = _ref.label,
    imageSuggestionText = _ref.imageSuggestionText,
    defaultPreviewImage = _ref.defaultPreviewImage,
    handleChange = _ref.handleChange;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var hasSelectedFiles = !!files && !!files.length;
  var _useState = (0, _react.useState)({
      previewName: defaultPreviewImage === null || defaultPreviewImage === void 0 ? void 0 : defaultPreviewImage.name,
      previewImage: defaultPreviewImage === null || defaultPreviewImage === void 0 ? void 0 : defaultPreviewImage.image
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    previewName = _useState2$.previewName,
    previewImage = _useState2$.previewImage,
    setImagePreview = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!defaultPreviewImage && !hasSelectedFiles) setImagePreview({
      previewName: undefined,
      previewImage: undefined
    });
    if (defaultPreviewImage && !hasSelectedFiles) setImagePreview({
      previewName: defaultPreviewImage === null || defaultPreviewImage === void 0 ? void 0 : defaultPreviewImage.name,
      previewImage: defaultPreviewImage === null || defaultPreviewImage === void 0 ? void 0 : defaultPreviewImage.image
    });
    if (hasSelectedFiles) {
      var reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = function (e) {
        return setImagePreview({
          previewName: files[0].name,
          previewImage: e.target.result
        });
      };
    }
  }, [defaultPreviewImage, previewName, previewImage, files, handleChange]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: classes.label,
    variant: "caption"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    sm: 12,
    md: 4,
    lg: 3
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.labelAndPreviewWrapper
  }, /*#__PURE__*/_react["default"].createElement(_material.Paper, {
    className: classes.previewContainer
  }, previewImage && previewName ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.previewImage,
    src: previewImage,
    alt: previewName
  }), hasSelectedFiles && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.previewAndDeleteContainer
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: classes.previewText
  }, t('inputs:imagePreview')), /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    onClick: function onClick() {
      return handleChange([]);
    },
    size: "small",
    color: "inherit",
    "aria-label": "remove",
    className: classes.deleteIcon
  }, /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
    fontSize: "small"
  })))) : /*#__PURE__*/_react["default"].createElement(_Panorama["default"], {
    fontSize: "large"
  })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    sm: 12,
    md: 8,
    lg: 9
  }, /*#__PURE__*/_react["default"].createElement(_FileInput["default"], {
    id: name,
    name: name,
    type: "image",
    withPreview: true,
    handleChange: handleChange,
    value: files,
    error: error,
    info: /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "caption",
      className: classes.imageInfo
    }, imageSuggestionText)
  })))));
};
ImageInput.propTypes = {
  value: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(File)).isRequired,
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  imageSuggestionText: _propTypes["default"].string.isRequired,
  handleChange: _propTypes["default"].func.isRequired,
  error: _propTypes["default"].string,
  defaultPreviewImage: _propTypes["default"].shape({
    image: _propTypes["default"].string,
    name: _propTypes["default"].string
  })
};
ImageInput.defaultProps = {
  defaultPreviewImage: undefined,
  error: undefined
};
var _default = ImageInput;
exports["default"] = _default;